import { comments } from './comments';
import { externalLink } from './external-links/';
import TDCPhotoSwipe from './lightbox/lightbox';
import { modal } from './modal';
// Initialize the lightbox when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    const lightbox = new TDCPhotoSwipe();
    // Add a small delay to ensure all images are loaded
    window.addEventListener('load', () => {
        // console.log('All resources finished loading');
    });
});
// Initialize all other components
comments();
externalLink();
modal();
//# sourceMappingURL=index.js.map